import { Validations, IValidationError } from './validation/validations';
import { ValidationTypeArgs } from './validation/validation_types';

export type PIVObject = Record<string, any>;
type PIVExpectedInput<T> = T extends number[] | string[] | PIVObject[] ? T[0] : T;

export const nestedKeyLookUp = (theObject: PIVObject, path: string, separator: string = '.') => {
  return path
    .replace('[', separator)
    .replace(']', '')
    .split(separator)
    .reduce((obj: PIVObject, property) => obj[property], theObject);
};

export class Validator {
  private __reportingPlatforms: Set<Function> = new Set();

  addReportingPlatform(fn: Function) {
    this.__reportingPlatforms.add(fn);
  }

  removeReportingPlatform(fn: Function) {
    this.__reportingPlatforms.delete(fn);
  }

  get reportingPlatforms() {
    return this.__reportingPlatforms;
  }

  performValidations<T, K extends keyof PIVExpectedInput<T>>(
    sourceDataObject: T,
    toObject: Record<K, ValidationTypeArgs>
  ) {
    const validations = new Validations();
    const validationErrors: IValidationError[] = [];
    const targetKeys = Object.keys(toObject);
    const validSourceKeys = Object.keys(sourceDataObject).filter((sourceKey) => targetKeys.includes(sourceKey));
    validSourceKeys.map((_sourceKey) => {
      const isSourceArray = sourceDataObject[_sourceKey] instanceof Array;
      const values: any[] = isSourceArray ? sourceDataObject[_sourceKey] : [sourceDataObject[_sourceKey]];
      values.forEach((value, index) => {
        const sourceKey = isSourceArray ? `${_sourceKey}[${index}]` : _sourceKey;

        if (!validations.validate(sourceDataObject, sourceKey, toObject[_sourceKey])) {
          validationErrors.push(validations.getErrorDetails(sourceDataObject, sourceKey, toObject[_sourceKey]));
        }
      });
    });

    return validationErrors;
  }

  validate<T, K extends keyof PIVExpectedInput<T>>(
    records: T,
    toObject: Record<K, ValidationTypeArgs>,
    nameOfTheValidation?: string
  ) {
    return new Promise<IValidationError[]>((resolve, reject) => {
      try {
        const recordList: T[] = records instanceof Array ? records : [records];
        const errors = recordList.reduce((errors, entry, index, _records) => {
          const entryErrors = this.performValidations(entry, toObject);
          if (entryErrors.length > 0) {
            errors = errors.concat(entryErrors);
          }
          return errors;
        }, [] as IValidationError[]);

        if (errors.length) {
          this.__reportingPlatforms.forEach((fn) => fn(errors, nameOfTheValidation));
        }
        resolve(errors);
      } catch (e) {
        console.warn('Validation library failed');
        this.__reportingPlatforms.forEach((fn) => fn(e, nameOfTheValidation));
        reject(e);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./app/vendor/pi-validation/src/index.ts